import "./App.css";
import { Routes, Route } from "react-router-dom";

import Home from "./Components/Pages/Home";
import World from "./Components/Pages/World";
import WorldStart from "./Components/Pages/WorldStart";
import Activities from "./Components/Pages/Activities";
import Map from "./Components/Pages/Map";
import Login from "./Components/Pages/Login";
import LoginFS from "./Components/Pages/LoginFullScreen";
import { ThemeProvider } from "./Components/ThemeContext/ThemeContext";
import { AuthProvider } from "./Components/auth/AuthContext";
import LoginProtectedRoute from "./Components/LoginProtectedRoute/LoginProtectedRoute";

import Profile from "./Components/Pages/Profile";
import Box from "./Components/Box/Box";
import ForgotPassword from "./Components/Pages/ForgotPassword";
import Signup from "./Components/Pages/Signup";
import Resources from "./Components/Pages/Resources";
import ActivityPage from "./Components/ActivityPage/ActivityPage";
import SupportPage from "./Components/Pages/Support";
import useInactivityTimer from "./Components/InactivityTimer/InactivityTimer";
import ResetPassword from "./Components/Pages/ResetPassword";
import NotFound from "./Components/NotFound/NotFound";

import React from "react";
import About from "./Components/Pages/About";
import Contact from "./Components/Pages/Contact";
import { WorldProvider } from "./context/WorldContext";

function App() {
  // Hook call here to initialize the inactivity timer
  useInactivityTimer(1800000); // clear the local storage and log user out in 30 minutes (in milliseconds)

  return (
    <AuthProvider>
      <ThemeProvider>
        <WorldProvider>
          <Routes>
            <Route
              path="/"
              element={
                <Box>
                  <Home />
                </Box>
              }
            />
            <Route
              path="/map"
              element={
                <Box>
                  <Map />
                </Box>
              }
            />
            <Route
              path="/about"
              element={
                <Box>
                  <About />
                </Box>
              }
            />
            <Route
              path="/contact"
              element={
                <Box>
                  <Contact />
                </Box>
              }
            />
            <Route
              path="/profile"
              element={
                <Box>
                  <Profile />
                </Box>
              }
            />
            <Route path="/world" element={<World />} />
            <Route
              path="/world-start"
              element={
                <Box>
                  <WorldStart />
                </Box>
              }
            />
            <Route
              path="/activities"
              element={
                <Box>
                  <Activities />
                </Box>
              }
            />
            <Route
              path="/resources"
              element={
                <Box>
                  <Resources />
                </Box>
              }
            />
            <Route path="/activity/:activityName" element={<ActivityPage />} />
            <Route
              path="/support"
              element={
                <Box>
                  <SupportPage />
                </Box>
              }
            />
            <Route
              path="*"
              element={
                <Box>
                  <NotFound />
                </Box>
              }
            />
          </Routes>
        </WorldProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
